// extracted by mini-css-extract-plugin
export var approach = "approach-module--approach--3cad7";
export var approach__block = "approach-module--approach__block--6bb87";
export var approach__block_advance = "approach-module--approach__block_advance--ee7b6";
export var approach__block_criteria = "approach-module--approach__block_criteria--e9ae1";
export var approach__block_usual = "approach-module--approach__block_usual--a365a";
export var approach__button = "approach-module--approach__button--4f612";
export var approach__course = "approach-module--approach__course--40291";
export var approach__undertext = "approach-module--approach__undertext--19b21";
export var approach__wrapper = "approach-module--approach__wrapper--c8d28";